/** @jsxImportSource @emotion/react */
import {
  NavLink, Link, useParams, useLocation, useHistory,
} from 'react-router-dom';
import Cookies from 'js-cookie';
import signOut from 'api/user/signout';

import { Icon } from 'components/common';
import { modules, applicantTabs } from './navItems';
import * as styles from './Navbar.styles';

const Navbar = () => {
  const history = useHistory();
  const { id } = useParams();
  const { pathname, search } = useLocation();
  const program = new URLSearchParams(search).get('program');
  const routerModule = pathname.split('/')[1];

  // Applicant detail pages live under /:id/..., so the program comes from the query string.
  const activeModuleKey = id ? (program || 'ftp') : routerModule;
  const activeModule = modules.find((mod) => mod.key === activeModuleKey);
  const programQuery = program ? `?program=${program}` : '';

  const handleLogout = () => {
    signOut()
      .then((response) => {
        if (response.status === 200) {
          Cookies.remove('access_token');
          history.push('/sign-in');
        }
      })
      .catch((err) => console.log(err, 'e'));
  };

  return (
    <header css={styles.headerStyles}>
      <div css={styles.topBarStyles}>
        <Link to="/batch" css={styles.brandStyles}>
          <img src="/h8.jpeg" alt="Hacktiv8" width="32" height="32" />
          <span>Admission</span>
        </Link>
        <nav css={styles.moduleNavStyles}>
          {modules.map((mod) => (
            <NavLink
              key={mod.key}
              to={mod.to}
              css={styles.moduleLinkStyles}
              isActive={() => mod.key === activeModuleKey}
            >
              {mod.label}
            </NavLink>
          ))}
        </nav>
        <button type="button" css={styles.logoutButtonStyles} onClick={handleLogout}>
          <Icon name="sign-out-alt" />
          Logout
        </button>
      </div>

      {
        !id && activeModule && activeModule.children.length > 0 && (
          <div css={styles.subNavStyles}>
            <nav css={styles.tabsStyles}>
              {activeModule.children.map((child) => (
                <NavLink key={child.to} to={child.to} css={styles.tabLinkStyles}>
                  {child.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )
      }

      {
        id && (
          <div css={styles.subNavStyles}>
            <nav css={styles.tabsStyles}>
              {
                applicantTabs
                  .filter((tab) => !(tab.ftpOnly && program === 'ptp'))
                  .map((tab) => (
                    <NavLink
                      key={tab.slug}
                      to={`/${id}/${tab.slug}${tab.ftpOnly ? '?program=ftp' : programQuery}`}
                      css={styles.tabLinkStyles}
                    >
                      {tab.label}
                    </NavLink>
                  ))
              }
            </nav>
          </div>
        )
      }
    </header>
  );
};

export default Navbar;
